module.exports = __webpack_public_path__ + "static/media/jedi.86c143f9.svg";